import React from 'react';
import CardContainer from 'react/containers/CardContainer';
import BookExtrasView from "react/views/bookExtras/BookExtrasView";
import AuthorAvatar from "react-icons/lib/md/account-circle";
import { getJsonData } from "data/DataStore";
import { getAuthorBiography } from 'data/AuthorBiographySelector';
import Icon from "react/views/generic/Icon";

const icon = <Icon icon={AuthorAvatar} color="rgba(47,85,151,1)" />;

const AuthorBioContainer = (props) => {
    let authorBioModel = getAuthorBiography(getJsonData());

    return(
        <CardContainer 
            cardModel={authorBioModel} 
            component={BookExtrasView}
            cardName="Author Biography"
            image={icon}
            title={authorBioModel && authorBioModel.name}
            text={authorBioModel && authorBioModel.body}
            {...props}
        />
    );
}

export default AuthorBioContainer;


// WEBPACK FOOTER //
// ./src/react/containers/authorBiography/AuthorBioContainer.jsx